import type { RgbaColor } from "../../../../../types.ts";

export const ASSET_LAYER_TYPE = "asset";
export const IMAGE_LAYER_TYPE = "image";
export const TEXT_LAYER_TYPE = "text";
export const SHAPE_LAYER_TYPE = "shape";
export const LINE_LAYER_TYPE = "line";

export const LAYER_TYPES = [
  ASSET_LAYER_TYPE,
  IMAGE_LAYER_TYPE,
  TEXT_LAYER_TYPE,
  SHAPE_LAYER_TYPE,
  LINE_LAYER_TYPE,
] as const;

export const RECT_SHAPE_TYPE = "rectangle";
export const CIRCLE_SHAPE_TYPE = "circle";
export const TRIANGLE_SHAPE_TYPE = "triangle";

export const SHAPE_TYPES = [
  RECT_SHAPE_TYPE,
  CIRCLE_SHAPE_TYPE,
  TRIANGLE_SHAPE_TYPE,
] as const;

export const TEXT_ALIGNMENTS = ["left", "center", "right", "justify"] as const;

export const STROKE_STYLES = ["solid", "dashed", "dotted", "dash-dot"] as const;

export const SHADOW_STYLES = ["none", "soft", "medium", "strong"] as const;
export const SHADOW_DIRECTIONS = ["top", "right", "bottom", "left"] as const;
export const SHADOW_DISTANCES = ["small", "medium", "large"] as const;

export const ALIGNMENT_SCOPES = ["canvas", "selection"] as const;
export const ALIGNMENT_ANCHORS = [
  "left",
  "right",
  "top",
  "bottom",
  "centerX",
  "centerY",
] as const;

export const DESIGNER_CANVAS_ID = "designer-canvas";

export const DEFAULT_BACKGROUND_COLOR: RgbaColor = {
  r: 255,
  g: 255,
  b: 255,
  a: 1,
};
